export default __webpack_public_path__ + "532fcec2f3cc130eb0811a6f094615ac.png";